import axios from 'axios'
import { processUserInformation, updateTokenInSession } from './getHeaderInformation'

// Fresh API call that bypasses all caches
export default async function getFreshHeaderInformation() {
  const timestamp = new Date().getTime()
  const url = `/insightweb/headerInformation?q=${timestamp}`
  
  try {
    const { data } = await axios.get(url)
    
    const result = {
      ...data,
      isAccountToolsEnabled: true,
      isCreateAccountEnabled: !data.isLoggedIn,
      isLimitedBuyer:
        data.isLoggedIn &&
        data.userInformation.loginTypeId === 10,
      isLiveChatEnabled:
        !data.isLoggedIn ||
        (data.isLoggedIn &&
          data.userInformation.permissions.enableLiveChat &&
          !data.userInformation.isLoginAs),
      isPhoneNumberEnabled: true,
      region: 'us',
      userInformation: processUserInformation(data.userInformation),
      isIPSUser:
        (data.isLoggedIn && data.userInformation.isIpsUser) || data.isIpsLogo,
      isSEWPUser: data.isSEWPUser,
      isCES: data.isLoggedIn && data.userInformation.isCES,
      currencyCode: data.isLoggedIn ? data.userInformation.currencyCode : '',
    }
    
    updateTokenInSession(data.jwtToken, data.isLoggedIn)
    return result
  } catch (error) {
    console.warn('Failed to fetch fresh user information', error)
    throw error
  }
}